<template>
  <div class="wrap">
    <!--检索-->
    <el-row type="flex" justify="space-between">
      <el-button size="medium" type="primary" @click="toAdd()">添加</el-button>
      <el-col>
        <div class="form-box">
          <div class="input-item">
            <el-input clearable size="medium" placeholder="请根据表单名称搜索" v-model="requestData.name_like">
              <el-button @click="request" slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
        </div>
      </el-col>
    </el-row>

    <!--表格数据-->
    <el-table :data="tableData" stripe style="width: 100%; margin-top: 20px;">
      <el-table-column prop="name" label="表单名称">
      </el-table-column>

      <!--            <el-table-column prop="submit_num" label="提交次数" align="center">-->
      <!--                <template slot-scope="scope">-->
      <!--                    <span :id="getId(scope.row.id)"></span>-->
      <!--                </template>-->
      <!--            </el-table-column>-->

      <el-table-column prop="" label="操作" align="right">
        <template slot-scope="scope">
          <el-button type="text" size="medium" @click="viewForm(scope.row)">查看表单</el-button>
          <el-button type="text" size="medium" @click="toCheck(scope.row)">查看提交内容</el-button>
          <el-button type="text" size="medium" @click="toDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="tableData" class="pagination-wrapper">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                     :page-size="requestData.count" layout="total, prev, pager, next" :total="totalNumber">
      </el-pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .wrap{
    background-color: #fff;
    padding: 20px;
  }
</style>

<script>
import Util from '../../js/util';

export default {
  name: 'FormList',
  data() {
    return {
      tableData: null,
      totalNumber: null,
      currentPage: 0,
      requestData: {
        page: 0,
        count: 20,
        name_like: '',
      },
      myCount: lib.cookie.get('mobile'),
      center: {lng: 120.1520955789, lat: 30.2443639356},
      curPosition: {lng: 120.1520955789, lat: 30.2443639356},
    };
  },

  created() {
    this.request();
  },

  methods: {
    request() {
      lib.tmsapi.get({
        api: 'api/test/form/list',
        data: this.requestData,
        success: data => {
          this.tableData = data.data;
          this.totalNumber = data.total;
        },
        error: data => {
          if (data && data.msg) {
            this.$message.error(data.msg);
          }
        },
        complete: () => {
        },
      });
    },
    getId(id) {
      return 'form-num-' + id;
    },
    toDelete(id, e) {
      this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.remove(id);
        })
        .catch(() => {
          // do sth
        });
    },

    toCheck(item) {
      lib.storage.set('formdata', item);
      this.$router.push({path: `/form/data/${item._id}`});
    },

    viewForm(item) {
      this.$router.push({path: `/form/view?id=${item._id}`});
    },

    toAdd() {
      this.$router.push({path: `/form/add`});
    },

    remove(id, cb) {
      var that = this;
      lib.tmsapi.post({
        api: 'api/test/form/delete',
        data: {
          id: id,
        },
        success: function (data) {
          that.$message.success('删除成功!');
          that.request();
        },
        error: function (data) {
          if (data && data.msg) {
            that.$message.error(data.msg);
          }
        },
        complete: function () {
        },
      });
    },

    handleCurrentChange(val) {
      this.requestData.page = val-1 || 0;
      this.request();
    },
  },
};
</script>
